import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const PasswordDialog = ({ open, onClose }) => {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });

  const save = async () => {
    if (f.new_password !== f.confirm) return toast.error("Les deux nouveaux mots de passe ne correspondent pas");
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Mot de passe modifié");
      setF({ current_password: "", new_password: "", confirm: "" });
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="password-dialog">
        <DialogHeader><DialogTitle>Changer mon mot de passe</DialogTitle></DialogHeader>
        <div className="grid gap-3">
          <Field label="Mot de passe actuel"><Input type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="pwd-current-input" /></Field>
          <Field label="Nouveau mot de passe (6 caractères min.)"><Input type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="pwd-new-input" /></Field>
          <Field label="Confirmer"><Input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="pwd-confirm-input" /></Field>
        </div>
        <DialogFooter><Button className="bg-red-600 hover:bg-red-700" onClick={save} data-testid="pwd-save-btn">Enregistrer</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
